import { t } from "@redotech/redo-i18n";
import { SetStatus } from "@redotech/redo-return-core-common/return-flow/action";
import {
  ActionType,
  SetStatusActionStatus,
  SetStatusSnoozePeriod,
} from "@redotech/redo-return-core-common/return-flow/action-enums";
import * as React from "react";
import { ActionTypeSetup, RuleTypeDetailsProps } from "./multiple-actions";

export interface SetStatusState {
  status: SetStatusActionStatus;
  snoozePeriod?: SetStatusSnoozePeriod;
}

export const SET_STATUS = (
  Details: React.ComponentType<RuleTypeDetailsProps<SetStatusState>>,
): ActionTypeSetup<SetStatusState, SetStatus> => ({
  get name() {
    return t("Set status");
  },
  description() {
    return t("Change the status of the ticket");
  },
  Details(props: RuleTypeDetailsProps<SetStatusState>) {
    return React.createElement(Details, props);
  },
  empty: { status: SetStatusActionStatus.OPEN },
  fromModel(model) {
    return { status: model.status, snoozePeriod: model.snoozePeriod };
  },
  toModel(state) {
    return {
      type: ActionType.SetStatus,
      status: state.status,
      snoozePeriod: state.snoozePeriod,
    };
  },
  valid(state) {
    if (state.status === SetStatusActionStatus.SNOOZED && !state.snoozePeriod) {
      return false;
    }
    return true;
  },
});
